/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./fb-login-fail.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./fb-login-fail.component";
import * as i3 from "@angular/router";
import * as i4 from "../../core/auth.service";
var styles_FbLoginFailComponent = [i0.styles];
var RenderType_FbLoginFailComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_FbLoginFailComponent, data: {} });
export { RenderType_FbLoginFailComponent as RenderType_FbLoginFailComponent };
export function View_FbLoginFailComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_FbLoginFailComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "fb-login-fail", [], null, null, null, View_FbLoginFailComponent_0, RenderType_FbLoginFailComponent)), i1.ɵdid(1, 114688, null, 0, i2.FbLoginFailComponent, [i3.ActivatedRoute, i3.Router, i4.AuthService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var FbLoginFailComponentNgFactory = i1.ɵccf("fb-login-fail", i2.FbLoginFailComponent, View_FbLoginFailComponent_Host_0, {}, {}, []);
export { FbLoginFailComponentNgFactory as FbLoginFailComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/fb-login-fail/fb-login-fail.component.ngfactory.js.pre-build-optimizer.js